import { CHANGETRIP, ADDADULT, MINUSADULT, ADDCHILDREN, MINUSCHILDREN, PICKDATE, ADDTOCART, REMOVEFROMCART, AIRPORTPICKUP, DIFFERENTHOTEL, MORETRIPS, REMOVEALL } from "./types";

export function changeTrip(id, e) {
  return { type: CHANGETRIP, payload: id, data: e.target.value };
}

export function addAdult(id, e) {
  e.preventDefault()
  return { type: ADDADULT, payload: id };
}

export function minusAdult(id, e) {
  e.preventDefault()
  return { type: MINUSADULT, payload: id };
}

export function addChildren(id, e) {
  e.preventDefault()
  return { type: ADDCHILDREN, payload: id };
}

export function minusChildren(id, e) {
  e.preventDefault()
  return { type: MINUSCHILDREN, payload: id };
}

export function pickDate(id, e) {
  return { type: PICKDATE, payload: id, data: e.target.value };
}

export function addToCart(id, e) {
  e.preventDefault()
  return { type: ADDTOCART, payload: id, data: e.target.value };
}

export function removeFromCart(id, e) {
  e.preventDefault()
  return { type: REMOVEFROMCART, payload: id, data: e.target.value };
}

export function airportPickUp(id, e) {
  return {type: AIRPORTPICKUP, payload: id, data: e.target.value}
}

export function differentHotel(id, e){
  return {type: DIFFERENTHOTEL, payload: id, data: e.target.value}
}

export function moreTrips(id, e){
  return {type: MORETRIPS, payload:id, data:e.target.value}
}

export function removeAll(){
  return {type: REMOVEALL}
}